import Swiper from "swiper";
import { Keyboard, Navigation, Pagination } from "swiper/modules";
import { devLogger } from "@/utils/dev-logger.util";
export function ArticleCarousel(element, _props) {
    const mobileBreakpoint = 768;
    const slidesPerView = 1;
    const spaceBetween = 16;
    let swiperInstance = null;
    let resizeTimeout = null;
    const cleanupFunctions = [];
    function isMobileView() {
        return window.innerWidth <= mobileBreakpoint;
    }
    function initialize() {
        const swiperContainer = element;
        if (!swiperContainer.querySelector(".swiper-wrapper")) {
            devLogger.error("[ArticleCarousel] Missing .swiper-wrapper");
            return;
        }
        if (!isMobileView()) {
            return;
        }
        const navigationPrev = swiperContainer.querySelector(".article-carousel-button-prev") ||
            element.parentElement?.querySelector(".article-carousel-button-prev") ||
            null;
        const navigationNext = swiperContainer.querySelector(".article-carousel-button-next") ||
            element.parentElement?.querySelector(".article-carousel-button-next") ||
            null;
        const paginationContainer = swiperContainer.querySelector(".carouse-swiper-pagination") ||
            element.parentElement?.querySelector(".carouse-swiper-pagination") ||
            null;
        const swiperOptions = {
            modules: [Navigation, Pagination, Keyboard],
            speed: 500,
            slidesPerView,
            spaceBetween,
            watchOverflow: true,
            loop: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            navigation: navigationPrev && navigationNext
                ? {
                    prevEl: navigationPrev,
                    nextEl: navigationNext,
                    disabledClass: "swiper-button-disabled",
                    lockClass: "swiper-button-lock",
                }
                : false,
            pagination: paginationContainer
                ? {
                    el: paginationContainer,
                    clickable: true,
                }
                : false,
            breakpoints: {
                [mobileBreakpoint + 1]: {
                    enabled: false,
                },
            },
        };
        swiperInstance = new Swiper(swiperContainer, swiperOptions);
    }
    function destroy() {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }
    function update() {
        destroy();
        initialize();
    }
    const handleResize = () => {
        const mobile = isMobileView();
        if (mobile && !swiperInstance) {
            initialize();
        }
        else if (!mobile && swiperInstance) {
            destroy();
        }
    };
    const debouncedResize = () => {
        if (resizeTimeout)
            clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            handleResize();
        }, 150);
    };
    window.addEventListener("resize", debouncedResize);
    cleanupFunctions.push(() => {
        window.removeEventListener("resize", debouncedResize);
        if (resizeTimeout)
            clearTimeout(resizeTimeout);
    });
    const handleReinit = () => {
        update();
    };
    element.addEventListener("carousel:reinit", handleReinit);
    cleanupFunctions.push(() => {
        element.removeEventListener("carousel:reinit", handleReinit);
    });
    destroy();
    initialize();
    return () => {
        cleanupFunctions.forEach((cleanup) => cleanup());
        destroy();
    };
}
